import omit from 'lodash.omit'
import React, { FunctionComponent, PropsWithChildren } from 'react'
import { Heading as BaseHeading } from 'theme-ui'
import { ThemeStyleObject } from '../'
export interface HeadingProps {
    /**
     * set heading as h1
     */
    h1?: boolean

    /**
     * set heading as h2
     */
    h2?: boolean

    /**
     * set heading as h3
     */
    h3?: boolean

    /**
     * set heading as h4
     */
    h4?: boolean

    /**
     * pass-through sx prop for styling
     */
    sx?: ThemeStyleObject

    /**
     * pass a heading variant, overrides h1,2,3,4
     */
    variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'cardTitle' | 'bigTitle'
}

/**
 * These are Headings to be used in webapps instead of h1/h2/etc
 * They come with default margins and font sizes.
 * Use the h1/h2/h3/h4 boolean prop to control size
 */
export const Heading: FunctionComponent<
    React.PropsWithChildren<PropsWithChildren<HeadingProps>>
> = ({ children, sx, variant, ...props }) => {
    let asProp: 'h1' | 'h2' | 'h3' | 'h4' = 'h1'

    if (props.h2) {
        asProp = 'h2'
    } else if (props.h3) {
        asProp = 'h3'
    } else if (props.h4) {
        asProp = 'h4'
    }

    return (
        <BaseHeading
            variant={variant ? variant : `text.${asProp}`}
            sx={{
                ...sx
            }}
            as={asProp}
            {...omit(props, ['h1', 'h2', 'h3', 'h4'])}
        >
            {children}
        </BaseHeading>
    )
}
